"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var react_fast_compare_1 = __importDefault(require("react-fast-compare"));
var AnnounceKit = /** @class */ (function (_super) {
    __extends(AnnounceKit, _super);
    function AnnounceKit(props) {
        var _this = _super.call(this, props) || this;
        _this.selector = ".ak-" + Math.random().toString(36).substring(10);
        _this.widgetHandlers = [];
        return _this;
    }
    AnnounceKit.prototype.shouldComponentUpdate = function (props) {
        var oldProps = {
            data: this.props.data,
            user: this.props.user,
            lang: this.props.lang,
            userToken: this.props.userToken,
            labels: this.props.labels
        };
        var newProps = {
            data: props.data,
            user: props.user,
            lang: props.lang,
            userToken: props.userToken,
            labels: props.labels
        };
        return !react_fast_compare_1.default(oldProps, newProps);
    };
    AnnounceKit.prototype.componentDidUpdate = function (prevProps) {
        var oldProps = {
            data: this.props.data,
            user: this.props.user,
            lang: this.props.lang,
            userToken: this.props.userToken,
            labels: this.props.labels
        };
        var newProps = {
            data: prevProps.data,
            user: prevProps.user,
            lang: prevProps.lang,
            userToken: prevProps.userToken,
            labels: prevProps.labels
        };
        if (!react_fast_compare_1.default(oldProps, newProps)) {
            if (this.widgetInstance) {
                this.widgetInstance.destroy();
                this.loaded();
            }
        }
    };
    AnnounceKit.prototype.componentDidMount = function () {
        var _a;
        if (typeof window === "undefined")
            return;
        if (!window["announcekit"]) {
            window["announcekit"] = window["announcekit"] || {
                queue: [],
                push: function (x) {
                    window["announcekit"].queue.push(x);
                },
                on: function (n, x) {
                    window["announcekit"].queue.push([n, x]);
                },
            };
            var scripttag = document.createElement("script");
            scripttag["async"] = true;
            scripttag["src"] = "https://cdn.announcekit.app/widget-v2.js";
            var scr = document.getElementsByTagName("script")[0];
            (_a = scr === null || scr === void 0 ? void 0 : scr.parentNode) === null || _a === void 0 ? void 0 : _a.insertBefore(scripttag, scr);
        }
        this.loaded();
    };
    AnnounceKit.prototype.loaded = function () {
        var _this = this;
        var style = this.props.widgetStyle;
        var styleParams = {
            badge: {
                style: style,
            },
            line: {
                style: style,
            },
            float: {
                style: style,
            },
        };
        if (this.props.floatWidget) {
            delete styleParams.badge;
            delete styleParams.line;
            this.selector = null;
        }
        this.name = Math.random().toString(36).substring(10);
        window["announcekit"].push(__assign(__assign({ widget: this.props.widget, name: this.name, version: 2, framework: "react", framework_version: "2.0.0", selector: this.selector, embed: this.props.embedWidget, boosters: typeof this.props.boosters === "undefined" ? true : this.props.boosters }, styleParams), { onInit: function (_widget) {
                if (_widget.conf.name !== _this.name) {
                    return _widget.destroy();
                }
                var ann = window["announcekit"];
                _this.widgetInstance = _widget;
                if (_this.props.catchClick) {
                    var elem = document.querySelector(_this.props.catchClick);
                    if (elem)
                        elem.addEventListener("click", function () { return _widget.open(); });
                }
                _this.widgetHandlers.forEach(function (h) { return h(_widget); });
                _this.widgetHandlers = [];
                ann.on("widget-open", function (_a) {
                    var widget = _a.widget;
                    if (widget === _widget && _this.props.onWidgetOpen) {
                        _this.props.onWidgetOpen({ widget: widget });
                    }
                });
                ann.on("widget-close", function (_a) {
                    var widget = _a.widget;
                    if (widget === _widget && _this.props.onWidgetClose) {
                        _this.props.onWidgetClose({ widget: widget });
                    }
                });
                ann.on("widget-resize", function (_a) {
                    var widget = _a.widget, size = _a.size;
                    if (widget === _widget && _this.props.onWidgetResize) {
                        _this.props.onWidgetResize({ widget: widget, size: size });
                    }
                });
                if (_this.props.onWidgetUnread) {
                    _this.props.onWidgetUnread(_widget.state.ui.unreadCount);
                }
            }, data: this.props.data, user: this.props.user, lang: this.props.lang, labels: this.props.labels, user_token: this.props.userToken }));
    };
    AnnounceKit.prototype.withWidget = function (fn) {
        var _this = this;
        return new Promise(function (res) {
            if (_this.widgetInstance) {
                return res(fn(_this.widgetInstance));
            }
            else {
                _this.widgetHandlers.push(function (widget) {
                    res(fn(widget));
                });
            }
        });
    };
    AnnounceKit.prototype.open = function () {
        return this.withWidget(function (widget) { return widget.open(); });
    };
    AnnounceKit.prototype.close = function () {
        return this.withWidget(function (widget) { return widget.close(); });
    };
    AnnounceKit.prototype.instance = function () {
        return this.withWidget(function (widget) { return widget; });
    };
    AnnounceKit.prototype.unread = function () {
        return this.withWidget(function (widget) { return widget.state.ui.unreadCount; });
    };
    AnnounceKit.prototype.render = function () {
        return (React.createElement("div", { style: { display: "inline" }, className: this.selector ? this.selector.slice(1) : "" }, this.props.children));
    };
    return AnnounceKit;
}(React.Component));
exports.default = AnnounceKit;
